import type {
  KenhBanHang,
  KenhBanHangHinhThucThanhToan,
  KenhBanHangNguonDon,
  KenhBanHangPhuongThucThanhToan
} from '@/types/schemas';
import type { DataTableColumn, GridRenderCellParams } from '@/components/custom/erp';

export const getDataTableColumns = (): DataTableColumn<KenhBanHang>[] => [
  {
    field: 'ma_kbh',
    headerName: 'Mã kênh bán hàng',
    width: 150
  },
  {
    field: 'ma_nguondon_data',
    headerName: 'Mã nguồn đơn',
    width: 150,
    renderCell: (params: GridRenderCellParams<KenhBanHang>) => params.row.ma_nguondon_data?.ma_nguondon || ''
  },
  {
    field: 'ma_cuahang',
    headerName: 'Mã cửa hàng',
    width: 150
  },
  {
    field: 'ma_httt_data',
    headerName: 'Hình thức thanh toán',
    width: 180,
    renderCell: (params: GridRenderCellParams<KenhBanHang>) => params.row.ma_httt_data?.ten_httt || ''
  },
  {
    field: 'ma_pttt_data',
    headerName: 'Phương thức thanh toán',
    width: 180,
    renderCell: (params: GridRenderCellParams<KenhBanHang>) => params.row.ma_pttt_data?.ten_pttt || ''
  },
  {
    field: 'tl_hoahong',
    headerName: 'Tỉ lệ hoa hồng',
    width: 120
  },
  {
    field: 'loai_kenh',
    headerName: 'Loại kênh',
    width: 100,
    renderCell: (params: GridRenderCellParams<KenhBanHang>) =>
      params.row.loai_kenh == 1 ? '1. Online' : params.row.loai_kenh == 2 ? '2. Tại chỗ' : params.row.loai_kenh
  }
];

export const nguonDonSearchColumns: DataTableColumn<KenhBanHangNguonDon>[] = [
  { field: 'ma_nguondon', headerName: 'Mã nguồn đơn', width: 150 },
  { field: 'ten_nguondon', headerName: 'Tên nguồn đơn', width: 250 }
];

export const hinhThucThanhToanSearchColumns: DataTableColumn<KenhBanHangHinhThucThanhToan>[] = [
  { field: 'ma_httt', headerName: 'Mã hình thức', width: 150 },
  { field: 'ten_httt', headerName: 'Tên hình thức', width: 250 }
];

export const phuongThucThanhToanSearchColumns: DataTableColumn<KenhBanHangPhuongThucThanhToan>[] = [
  { field: 'ma_pttt', headerName: 'Mã phương thức', width: 150 },
  { field: 'ten_pttt', headerName: 'Tên phương thức', width: 250 }
];
